import React, { ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import RequiredMark from '../../../../components/required-mark/required-mark.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';

const SettingsPortfolioGroupGeneral: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isRightDrawerOpen,
    isEditMode,
    portfolioGroupData,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      {
        portfolioGroupData && (
          <Table>
            <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
              <TableRow>
                <TableCell>
                  Name
                  {
                    isEditMode && <RequiredMark />
                  }
                </TableCell>
                <TableCell>
                  {
                    isEditMode ? (
                      <FormFieldText isBordered name="name" />
                    ) : portfolioGroupData.name
                  }
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )
      }
    </SinglePageTab>
  );
});

export default SettingsPortfolioGroupGeneral;
